export enum TokenType {
    FACEBOOK = 'FacebookAccessToken',
    GOOGLE = 'GoogleAccessToken',
    LOCAL = 'Local',
    APPLE = 'AppleAccessToken'
}

export enum LoginType {
    FACEBOOK = 'Facebook',
    GOOGLE = 'Google',
    LOCAL = 'Local',
    APPLE = 'Apple'
}
